import {ExperienceCertificate, SignatureStatus} from "../models/AllModels"

export const isExperienceVerified = (experience: ExperienceCertificate) => {
    let result    = undefined
    result = experience.verifications && experience.verifications.length > 0
    if(result && !!experience.verifications){
        result = experience.verifications.filter(verification => verification.signatureStatus !== SignatureStatus.Draft).length > 0
    }
    return result
}